<div>

  <div class="grid grid-cols-3 gap-4 relative mobile:grid-cols-1 mobile:gap-4">

    @for (institution of (institutions$ | async); track institution; let i = $index) {
      <div
        class=" graduation-item-cont cursor-pointer "
        style="height: 225px;"
        (click)="toggleInstitution(institution)" >
        <div class="graduation-outer-item">
          <div class="graduation-item front rounded-lg">
            <div class="institute-logo-cont bg-white h-36 border-4 box-content border-white rounded-t-lg flex justify-center items-center">
              <img src="assets/logos/{{ institution.institution_id }}.png" class="w-80 h-28 object-contain">
            </div>
            <div class="relative text-xl font-medium justify-center bg-white shadow-md rounded-b-lg" >
              @if (selectedInstitution?.institution_id !== institution.institution_id) {
                <div class="hover-check-circle absolute right-0 mr-3 h-full flex items-center">
                  <fa-icon class="text-4xl" [icon]="faCheckCircle"></fa-icon>
                </div>
              }
              @if (selectedInstitution?.institution_id === institution.institution_id) {
                <div class="absolute right-0 mr-3 h-full flex items-center">
                  <fa-icon class="text-gwc-blue-500 flex-shrink-0 text-4xl leading-8" [icon]="faCheckCircle"></fa-icon>
                </div>
              }
              <div class="py-2 min-h-18 text-black flex items-center justify-center bg-slate-200 rounded-b-lg">
                <div class="text-center">{{ institution.institution }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

  </div>

</div>